export enum CustomerStatus {
  Current = "current",
  FrankfordTarget = "frankford target",
  PriorityA = "priority a",
  PriorityB = "priority b",
  Lost = "lost"
}

export enum CustomerType {
  Customer = "customer",
  Contract = "contract dealer",
  BeachConcession = "beach concession",
  Designer = "designer"
}

export enum CustomerDiscounts {
  Standard = "std",
  Reorder = "reorder",
  EarlyBuy = "eb"
}

export enum SalesRegions {
  Central = "central",
  Florida = "florida",
  MidAtlantic = "mid-atlantic",
  Midwest = "midwest",
  NewEngland = "new england",
  NewYork = "new york",
  NorthCentral = "north central",
  NorthernCalifornia = "northern california",
  PacificNorthwest = "pacific northwest",
  South = "south",
  SouthCentral = "south central",
  SouthernCalifornia = "southern california",
  Southwest = "southwest",
  TriState = "tri-state",
  Virginia = "virginia",
  Unassigned = "unassigned"
}
